import { render, staticRenderFns } from "./proTableTop.vue?vue&type=template&id=3b46a971&scoped=true"
import script from "./proTableTop.vue?vue&type=script&lang=js"
export * from "./proTableTop.vue?vue&type=script&lang=js"
import style0 from "./proTableTop.vue?vue&type=style&index=0&id=3b46a971&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b46a971",
  null
  
)

export default component.exports